import React from 'react';
import { getTranslateByScope } from '../../i18n';
import { SKI_CLUSTER } from '../../constants';
import { Clusters } from './Clusters';

const translate = getTranslateByScope('app.clusters.skiClusters');

export const SkiClusters = (props) => (
  <Clusters title={translate('title')} clusterType={SKI_CLUSTER} {...props} />
);
